import React from 'react';
import PropTypes from 'prop-types';
// import { Card, CardHeader } from 'reactstrap';
import {
  PlusCircleOutlined,
  LeftOutlined,
  RightOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { Document, Outline, Page } from 'react-pdf';

// import ReactTable from 'react-table';
// import { Row, Col } from 'reactstrap';
import { Collapse, Modal, Select, Button, Tag } from 'antd';
// // Local Deps
import { tomcatHost, cloudFrontCdnUrl } from '../../config/properties';
import history from '../../config/history';

import Loading from '../../components/Loading';
import RFQRecipientGrid from '../../components/grids/RFQRecipientGrid';
import RFQEditForm from '../../components/forms/EditRFQForm';
import './ContractRFQ.scss';
import ContractRFQHOC from './ContractRFQHOC';

const { Panel } = Collapse;
const ContractRFQ = (props) => {
  const {
    auth,
    handleFormSubmit,
    initialValues,
    organizationList,
    onRecipientSelect,
    handleRecipientAdd,
    visible,
    handleRecipientCancel,
    showModal,
    confirmRfqSubmit,
    confirmRfqCancel,
    updateRFQ,
    changeDate,
    onDocumentLoadSuccess,
    numPages,
    nextPage,
    previousPage,
    pageNumber,
    downloadNDA,
    showPdfModal,
    viewPDF,
    selectedNda,
    changeSelectValue,
    handleUpload,
    fileList,
    handleUploadChange,
    participants,
    discardChanges,
    handleSelectedActions,
    readOnly,
    rfqStatus,
    loading,
    handleAttachmentUploadChange,
    attachmentFileList,
    removeAttachments,
  } = props;

  return (
    <div className="edit-contract-wrapper">
      <div id="mybutton">
        <Button
          className="floating-back"
          onClick={() => {
            history.goBack();
          }}
        >
          Go Back
        </Button>
      </div>
      {loading && <Loading text="Locating RFQ" />}
      {!loading && (
        <Collapse defaultActiveKey={['1', '2']}>
          <Panel
            header={
              <div
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                {' '}
                <div> RFQ Details </div>{' '}
                <div>
                  Status:{' '}
                  <Tag
                    color={
                      rfqStatus === 'Cancelled'
                        ? 'red'
                        : rfqStatus === 'Submitted'
                          ? 'green'
                          : ''
                    }
                  >
                    {' '}
                    {rfqStatus}
                  </Tag>
                </div>{' '}
              </div>
            }
            key="1"
          >
            <RFQEditForm
              viewPDF={viewPDF}
              changeDate={changeDate}
              handleUpload={handleUpload}
              handleUploadChange={handleUploadChange}
              handleAttachmentUploadChange={handleAttachmentUploadChange}
              changeSelectValue={changeSelectValue}
              fileList={fileList}
              attachmentFileList={attachmentFileList}
              onSubmit={handleFormSubmit}
              initialValues={initialValues}
              readOnly={readOnly}
              removeAttachments={removeAttachments}
            />
          </Panel>
          <Panel header="Recipients" key="2">
            <div className="contract-center-actions-wrapper">
              <div className="contract-center-actions">
                <button onClick={showModal}>
                  <PlusCircleOutlined /> Add recipients
                </button>
              </div>
            </div>

            <RFQRecipientGrid
              readOnly={readOnly}
              participants={participants}
              handleSelectedActions={handleSelectedActions}
            />
          </Panel>
        </Collapse>
      )}
      {!loading && (
        <div className="quote-button-wrapper">
          {rfqStatus !== 'Cancelled' && (
            <Button type="primary" danger onClick={confirmRfqCancel}>
              Cancel RFQ
            </Button>
          )}

          {!readOnly && (
            <div>
              <Button
                type="primary"
                style={{
                  background: '#ff7c52',
                  color: 'white',
                  borderColor: '#ff7c52',
                }}
                onClick={discardChanges}
              >
                Discard Changes
              </Button>
              <Button type="primary" onClick={() => updateRFQ()}>
                Save Changes
              </Button>
              <Button
                style={{
                  background: '#2ebd38',
                  color: 'white',
                  borderColor: '#2ebd38',
                }}
                onClick={confirmRfqSubmit}
              >
                Submit RFQ
              </Button>
            </div>
          )}
        </div>
      )}
      <Modal
        title="Add A Recipient"
        visible={visible}
        onOk={handleRecipientAdd}
        destroyOnClose
        onCancel={handleRecipientCancel}
      >
        <Select
          showSearch
          style={{ width: '100%' }}
          placeholder="Select an Organization"
          optionFilterProp="children"
          onChange={onRecipientSelect}
          filterOption={(input, option) =>
            option.props.children
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0
          }
        >
          {organizationList}
        </Select>
      </Modal>
      <Modal
        title="NDA"
        visible={showPdfModal}
        onOk={viewPDF}
        destroyOnClose
        onCancel={viewPDF}
        width={1000}
      >
        <div>
          <Document
            file={{
              url: `${cloudFrontCdnUrl}/${tomcatHost}/rfq/attachment/nda/${selectedNda || initialValues.ndaId}`,
              httpHeaders: { 'Authorization': `Bearer ${auth.jwtToken}` }
            }}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            <Outline />
            <Page pageNumber={pageNumber} />
          </Document>
          <div>
            <p>
              Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
            </p>
            <div className="help-button-container">
              <Button
                shape="circle"
                icon={<LeftOutlined />}
                disabled={pageNumber <= 1}
                onClick={previousPage}
              />
              <Button
                shape="circle"
                icon={<RightOutlined />}
                disabled={pageNumber >= numPages}
                onClick={nextPage}
              />
              <br />
              <Button
                primary
                shape="circle"
                icon={<DownloadOutlined />}
                onClick={downloadNDA}
              // title={[nFile]}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

ContractRFQ.propTypes = {
  auth: PropTypes.any.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    id: PropTypes.string.isRequired,

    description: PropTypes.string,
    solNum: PropTypes.string,
    niin: PropTypes.string,
    partNum: PropTypes.string,
    partDesc: PropTypes.string,
    quoteDueDate: PropTypes.string,
    sampleDueDate: PropTypes.string,
    orderDueDate: PropTypes.string,
    qty: PropTypes.string,
    releaseQty: PropTypes.string,
    castingWt: PropTypes.string,
    toolingAvailable: PropTypes.string,
    sampleAvailable: PropTypes.string,
    machiningReq: PropTypes.string,
    toolingDesc: PropTypes.string,
    prefCastProc: PropTypes.string,
    secOpsReq: PropTypes.string,
    reqCastSpec: PropTypes.string,
    testingRqmts: PropTypes.string,
    comment: PropTypes.string,
    drawingNums: PropTypes.string,
    nda: PropTypes.object,
    ndaId: PropTypes.string,
    ndaList: PropTypes.array,
    attachmentsList: PropTypes.array,
  }).isRequired,
  visible: PropTypes.bool,
  handleRecipientAdd: PropTypes.func,
  handleRecipientCancel: PropTypes.func,
  organizationList: PropTypes.array.isRequired,
  onRecipientSelect: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  confirmRfqSubmit: PropTypes.func.isRequired,
  confirmRfqCancel: PropTypes.func.isRequired,
  updateRFQ: PropTypes.func.isRequired,
  changeDate: PropTypes.func.isRequired,
  onDocumentLoadSuccess: PropTypes.func.isRequired,
  numPages: PropTypes.number.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  downloadNDA: PropTypes.func.isRequired,
  showPdfModal: PropTypes.bool.isRequired,
  viewPDF: PropTypes.func.isRequired,
  selectedNda: PropTypes.string.isRequired,
  changeSelectValue: PropTypes.func.isRequired,
  handleUpload: PropTypes.func.isRequired,
  fileList: PropTypes.any.isRequired,
  handleUploadChange: PropTypes.func.isRequired,
  attachmentFileList: PropTypes.func.isRequired,
  handleAttachmentUploadChange: PropTypes.func.isRequired,
  participants: PropTypes.array.isRequired,
  discardChanges: PropTypes.func.isRequired,
  handleSelectedActions: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  rfqStatus: PropTypes.string.isRequired,
  removeAttachments: PropTypes.func.isRequired,
};

ContractRFQ.defaultProps = {
  visible: true,
  handleRecipientAdd: e => {
    console.log(e);
  },
  handleRecipientCancel: e => {
    console.log(e);
  },
};

export default ContractRFQHOC(ContractRFQ);



// WEBPACK FOOTER //
// ./src/pages/contractRFQ/ContractRFQ.jsx